import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledSuperAdminMain = styled(Layout)`
  transition: all 0.1s linear;
  width: 100% !important;
  position: relative;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};

  & .trigger {
    display: none;
  }
`;
